import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/home/index-7.png';
import _imports_1 from '../../assets/img/home/index-10.png';
import _imports_2 from '../../assets/img/home/index-4.png';
import _imports_3 from '../../assets/img/home/index-3.png';
import _imports_4 from '../../assets/img/home/index-6.png';
import _imports_5 from '../../assets/img/home/index-13.png';
import _imports_6 from '../../assets/img/home/index-12.png';
import _imports_7 from '../../assets/img/home/index-11.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1bd923c0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  ref: "MyHome",
  class: "My-Home"
};
var _hoisted_2 = {
  class: "My-Swiper"
};
var _hoisted_3 = {
  class: "block"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "Swiper"
};
var _hoisted_6 = {
  class: "Swiper-box"
};
var _hoisted_7 = {
  class: "Swiper-title"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode("/");

var _hoisted_9 = {
  class: "Swiper-text"
};
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = {
  class: "Ning-Swiper"
};
var _hoisted_12 = {
  ref: "mySwiper",
  class: "swiper"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_14 = [_hoisted_13];
var _hoisted_15 = {
  class: "swiper-wrapper"
};
var _hoisted_16 = ["onClick"];

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});

var _hoisted_18 = [_hoisted_17];
var _hoisted_19 = {
  class: "My-Tabs"
};
var _hoisted_20 = {
  class: "tabs-box content-heart My-public"
};
var _hoisted_21 = ["src"];
var _hoisted_22 = {
  class: "title My-Pointer"
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "RULES AND REGULATIONS", -1);
});

var _hoisted_24 = /*#__PURE__*/_createTextVNode(" 查看更多 ");

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1);
});

var _hoisted_26 = [_hoisted_24, _hoisted_25];
var _hoisted_27 = {
  class: "tabs-content"
};

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", null, "loading.....")], -1);
});

var _hoisted_29 = [_hoisted_28];
var _hoisted_30 = ["onClick"];
var _hoisted_31 = {
  key: 0,
  class: "wudata"
};
var _hoisted_32 = {
  key: 0,
  class: "My-News content-heart My-public"
};

var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "News-title My-Pointer"
  }, [/*#__PURE__*/_createElementVNode("div", null, "资料下载"), /*#__PURE__*/_createElementVNode("div", null, "RECOGNITION AND PUNISHMENT")], -1);
});

var _hoisted_34 = {
  class: "News-content"
};
var _hoisted_35 = ["onClick"];
var _hoisted_36 = {
  class: "right"
};
var _hoisted_37 = {
  class: "right-title My-Pointer"
};
var _hoisted_38 = {
  class: "ull"
};
var _hoisted_39 = {
  key: 1,
  class: "My-Dynamic content-heart My-public"
};
var _hoisted_40 = {
  class: "Dynamic-left"
};

var _hoisted_41 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "Dynamic-title"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "My-Pointer"
  }, " 规章制度 "), /*#__PURE__*/_createElementVNode("div", {
    class: "My-Pointer"
  }, " RULES AND DISCIPLINES ")], -1);
});

var _hoisted_42 = {
  class: "Dynamic-First"
};
var _hoisted_43 = ["innerHTML"];

var _hoisted_44 = /*#__PURE__*/_createTextVNode(" 查看更多");

var _hoisted_45 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }, null, -1);
});

var _hoisted_46 = [_hoisted_44, _hoisted_45];
var _hoisted_47 = {
  class: "Dynamic-other"
};
var _hoisted_48 = ["onClick"];
var _hoisted_49 = {
  class: "My-OverFlow"
};

var _hoisted_50 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "Dynamic-right"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  })])], -1);
});

var _hoisted_51 = {
  key: 2,
  class: "My-Study content-heart My-public"
};

var _hoisted_52 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "Study-Title"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "My-Pointer"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  })]), /*#__PURE__*/_createElementVNode("div", {
    class: "My-Pointer"
  }, " 在线学习 "), /*#__PURE__*/_createElementVNode("div", {
    class: "My-Pointer"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  })])], -1);
});

var _hoisted_53 = {
  class: "Study"
};
var _hoisted_54 = {
  key: 0,
  class: "Study-box"
};

var _hoisted_55 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "Study-title"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "My-Pointer"
  }, " 两学一做 "), /*#__PURE__*/_createElementVNode("div", {
    class: "My-Pointer"
  }, " LEARN TWO AND DO ONE ")], -1);
});

var _hoisted_56 = {
  class: "Study-other"
};
var _hoisted_57 = ["onClick"];
var _hoisted_58 = {
  class: "My-OverFlow"
};

var _hoisted_59 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })], -1);
});

var _hoisted_60 = {
  key: 1,
  class: "Study-box"
};

var _hoisted_61 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "Study-title"
  }, [/*#__PURE__*/_createElementVNode("div", null, "三会一课"), /*#__PURE__*/_createElementVNode("div", null, "THREE MEETINGS AND ONE LESSON")], -1);
});

var _hoisted_62 = {
  class: "Study-other"
};
var _hoisted_63 = ["onClick"];
var _hoisted_64 = {
  class: "My-OverFlow"
};

var _hoisted_65 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })], -1);
});

var _hoisted_66 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "My-Footer"
  }, [/*#__PURE__*/_createElementVNode("p", null, "版权所有：北京北信源股份软件有限公司")], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_carousel_item = _resolveComponent("el-carousel-item");

  var _component_el_carousel = _resolveComponent("el-carousel");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_carousel, {
    height: _ctx.Data.carouselHeight,
    autoplay: false
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.carouselData, function (item, index) {
        return _openBlock(), _createBlock(_component_el_carousel_item, {
          key: index,
          onClick: function onClick($event) {
            return _ctx.todetails(item);
          }
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", null, [_createElementVNode("img", {
              ref: "bannerHeight",
              class: "imh",
              src: _ctx.baseUrl + item.imgUrl,
              alt: "",
              style: _normalizeStyle({
                height: _ctx.Data.carouselHeight
              }),
              onLoad: _cache[0] || (_cache[0] = //@ts-ignore
              function () {
                return _ctx.imgLoad && _ctx.imgLoad.apply(_ctx, arguments);
              })
            }, null, 44, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(index + 1), 1), _hoisted_8, _createElementVNode("span", null, _toDisplayString(_ctx.Data.carouselData.length), 1)]), _createElementVNode("div", null, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
              class: "My-OverFlows",
              innerHTML: item.content
            }, null, 8, _hoisted_10)])])])])];
          }),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["height"])])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("div", {
    class: "swiper-left",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.handleAllClick('left');
    })
  }, _hoisted_14, 512), [[_vShow, _ctx.Data.tabsCurrentIndex > 0]]), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.tabsData, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["swiper-slide", {
        isActive: item.isTrue
      }]),
      onClick: function onClick($event) {
        return _ctx.swiperClick(item, index);
      }
    }, _toDisplayString(item.columnName), 11, _hoisted_16);
  }), 128))]), _withDirectives(_createElementVNode("div", {
    class: "swiper-right",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.handleAllClick('right');
    })
  }, _hoisted_18, 512), [[_vShow, _ctx.Data.tabsCurrentIndex < _ctx.Data.tabsData.length - 1]])], 512)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", null, [_createElementVNode("img", {
    class: "newimg",
    src: _ctx.baseUrl + _ctx.imgUrl
  }, null, 8, _hoisted_21)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", null, _toDisplayString(_ctx.Data.newList[0].columnName), 1), _hoisted_23, _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.jumpdetail(_ctx.Data.newList[0].columnId);
    })
  }, _hoisted_26)]), _createElementVNode("div", _hoisted_27, [_withDirectives(_createElementVNode("div", null, _hoisted_29, 512), [[_vShow, _ctx.isshow]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.newList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "tabs-content-box My-Pointer",
      onClick: function onClick($event) {
        return _ctx.todetails(item);
      }
    }, [!_ctx.isshow && item.createUserId == -5 ? (_openBlock(), _createElementBlock("div", _hoisted_31, " 暂无数据 ")) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString(item.title), 1), _createElementVNode("div", null, _toDisplayString(item.releaseTime), 1)], 8, _hoisted_30);
  }), 128))])])])]), _ctx.Data.punishment.length != 0 && _ctx.Data.punishmentFlag ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.punishment, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["News-content-box", {
        bott: !(_ctx.Data.punishment.length % 2 == 0 ? index == _ctx.Data.punishment.length - 1 || index == _ctx.Data.punishment.length - 2 : index == _ctx.Data.punishment.length - 1)
      }]),
      onClick: function onClick($event) {
        return _ctx.todeta(item);
      }
    }, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("ul", _hoisted_38, [_createElementVNode("li", null, _toDisplayString(item.title), 1)])])])], 10, _hoisted_35);
  }), 128))])])) : _createCommentVNode("", true), _ctx.Data.stymone && _ctx.Data.stymoneFlag ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, [_createElementVNode("div", {
    class: "First-title My-OverFlow My-Pointer",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return _ctx.todeta(_ctx.Data.stymone);
    })
  }, _toDisplayString(_ctx.Data.stymone.title), 1), _createElementVNode("div", {
    class: "First-time My-OverFlow My-Pointer",
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return _ctx.todeta(_ctx.Data.stymone);
    })
  }, _toDisplayString(_ctx.Data.stymone.createDate), 1), _createElementVNode("div", {
    class: "First-text My-OverFlows My-Pointer",
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return _ctx.todeta(_ctx.Data.stymone);
    }),
    innerHTML: _ctx.Data.stymone.richText
  }, null, 8, _hoisted_43), _createElementVNode("div", {
    class: "First-more My-Pointer",
    onClick: _cache[7] || (_cache[7] = function ($event) {
      return _ctx.jumpdetail(-1);
    })
  }, _hoisted_46)]), _createElementVNode("div", _hoisted_47, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.stymList, function (item) {
    return _openBlock(), _createElementBlock("li", {
      key: item,
      class: "My-Pointer",
      onClick: function onClick($event) {
        return _ctx.todeta(item);
      }
    }, [_createElementVNode("div", _hoisted_49, _toDisplayString(item.title), 1), _createElementVNode("div", null, _toDisplayString(item.createDate), 1)], 8, _hoisted_48);
  }), 128))])])]), _hoisted_50])) : _createCommentVNode("", true), _ctx.Data.learnlistFlag || _ctx.Data.lessonListFlag ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_hoisted_52, _createElementVNode("div", _hoisted_53, [_ctx.Data.learnLisFlag ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_hoisted_55, _createElementVNode("div", _hoisted_56, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.learnlist, function (item) {
    return _openBlock(), _createElementBlock("li", {
      key: item,
      class: "My-Pointer",
      onClick: function onClick($event) {
        return _ctx.todeta(item);
      }
    }, [_createElementVNode("div", _hoisted_58, _toDisplayString(item.title), 1), _hoisted_59], 8, _hoisted_57);
  }), 128))])])])) : _createCommentVNode("", true), _ctx.Data.lessonListFlag ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_hoisted_61, _createElementVNode("div", _hoisted_62, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.lessonList, function (item) {
    return _openBlock(), _createElementBlock("li", {
      key: item,
      class: "My-Pointer",
      onClick: function onClick($event) {
        return _ctx.todeta(item);
      }
    }, [_createElementVNode("div", _hoisted_64, _toDisplayString(item.title), 1), _hoisted_65], 8, _hoisted_63);
  }), 128))])])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _hoisted_66], 512);
}